import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { IArticle } from '../../shared/types/articles';
import { ICatalogItem } from '../../shared/types/catalog-items';
import { ICatalog, IMainCatalogItem } from '../../shared/types/main-catalog';
import { IService } from '../../shared/types/services';

import { fetchArticles, fetchMainCatalog, fetchServices } from './main.actions';
import { MainPageState } from './main.interface';

const initialState: MainPageState = {
  processes: [],
  materials: [],
  equipments: [],
  services: {
    catalog_services: [],
    service_profile_list: [],
  },
  articles: [],
  loading: false,
};

export const mainPageSlice = createSlice({
  name: 'mainPageSlice',
  initialState,
  reducers: {},
  extraReducers: {
    [fetchMainCatalog.rejected.type]: (state) => {
      state.processes = [];
      state.materials = [];
      state.equipments = [];
    },
    [fetchMainCatalog.pending.type]: (state) => {
      state.loading = true;
    },
    [fetchMainCatalog.fulfilled.type]: (
      state,
      action: PayloadAction<ICatalog>
    ) => {
      state.processes = action.payload.processes;
      state.materials = action.payload.materials;
      state.equipments = action.payload.equipments;
      state.loading = false;
    },
    [fetchArticles.fulfilled.type]: (
      state,
      action: PayloadAction<IArticle[]>
    ) => {
      state.articles = action.payload;
    },
    [fetchServices.fulfilled.type]: (
      state,
      action: PayloadAction<IService>
    ) => {
      state.services = action.payload;
    },
  },
});

export const { reducer } = mainPageSlice;
